var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselNavArrowLeft = function SvgCarouselNavArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    style: {
      fill: "none"
    },
    viewBox: "0 0 81 81.121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 5.486c27 15.589 27 54.56 0 70.148S0 71.737 0 40.56C0 9.384 33.75-10.102 60.75 5.486z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.93 25.56 29.499 40.477l15.43 14.916",
    style: {
      strokeLinecap: "square",
      strokeWidth: 5,
      stroke: "#fff"
    }
  }));
};
export { SvgCarouselNavArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHN0eWxlPSJmaWxsOm5vbmUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDgxIDgxLjEyMDYyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Im02MC43NSA1LjQ4NjQxMjljMjcgMTUuNTg4NDAwMSAyNyA1NC41NjAwMDAxIDAgNzAuMTQ4MDAwMXMtNjAuNzUtMy44OTctNjAuNzUtMzUuMDc0YzAtMzEuMTc2OTAwMSAzMy43NS01MC42NjI1IDYwLjc1LTM1LjA3NDAwMDF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KIDxwYXRoIGQ9Im00NC45Mjk3IDI1LjU2MDQxMy0xNS40MzA4IDE0LjkxNjQgMTUuNDMwOCAxNC45MTY1IiBzdHlsZT0ic3Ryb2tlLWxpbmVjYXA6c3F1YXJlO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojZmZmIi8+Cjwvc3ZnPgo=";